import(/* webpackMode: "eager" */ "/app/src/components/layout/Footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/GlobalSocialProofBanner.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/InAppBrowserBanner.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/Navbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/NewsletterTab.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/WhatsAppButton.js");
